// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e295fdc0","581":"bc2db12d"}[chunkId] + ".chunk.js";
};